import styled from "styled-components";

export const OffersContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	gap: 1em;
	font-size: 1rem;

	@media (orientation: landscape) {
		font-size: clamp(0.68rem, 1.5vw, 1rem);

		flex-direction: row;
		//justify-content: flex-start;
		flex-wrap: nowrap;
	}
`;
